module.exports = __webpack_public_path__ + "img/04_kii_16.7b5acddf.jpg";